<template>
    <div v-if="contrato.IdContrato > 0">
        <card-collapse titulo="Dados Gerais">
        <b-row class="m-2">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>N°/Ano</b></span>
                <br />
                <span class="pos-left">{{ contrato.NrContrato+"/"+contrato.NrAnoContrato }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Tipo</b></span>
                <br />
                <span class="pos-left">{{ contrato.IdTipoContratoNavigation.DeTipoContrato }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Objeto</b></span>
                <br />
                <span class="pos-left">{{ contrato.DeObjetoContrato }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data de Assinatura</b></span>
                <br />
                <span class="pos-left">{{ contrato.DtAssinatura ? formatData(contrato.DtAssinatura) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data de Publicacao</b></span>
                <br />
                <span class="pos-left">{{ contrato.DtPublicacao ? formatData(contrato.DtPublicacao) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Início de Vigência</b></span>
                <br />
                <span class="pos-left">{{ contrato.DtInicioVigencia ? formatData(contrato.DtInicioVigencia) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Fim de Vigência</b></span>
                <br />
                <span class="pos-left">{{ contrato.DtFimVigencia ? formatData(contrato.DtFimVigencia) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Baixar arquivo texto do Edital (PDF) *</b></span>
                <div class="wrapper-icon">
                    <btn-download :fazerDownload="() => baixarAnexo('edital')" :texto="''" />
                </div>
            </b-col>
        </b-row>
        </card-collapse>
        <card-collapse titulo="Procedimento de Origem" v-if="contrato.FlTipoProcedOrigem !== null">
            <b-col cols="12" class="text-left mb-2">
                <span><b>Tipo</b> {{ contrato.DescricaoProcedimentoOrigem }}</span>
            </b-col>
            <b-col v-if="procedimentosOrigemDispensa.includes(contrato.FlTipoProcedOrigem)" cols="12" class="text-left mb-2">
                <span><b>Há previsão de pagamento antecipado?</b> {{ contrato.FlPagamentoAntecipado === "S" ? 'Sim' : 'Não' }}</span>
            </b-col>
            <detalhes-contrato-licitacao-outra-ug v-if="contrato.FlTipoProcedOrigem === 'U'" :ctrLicOutraUg="contrato.ContratoLicitacaoOutraUg"/>
            <detalhes-contrato-centralizado v-if="contrato.FlTipoProcedOrigem === 'C'" :ctrCentralizado="contrato.ContratoCentralizado"/>
            <detalhes-contrato-registro-preco v-if="contrato.FlTipoProcedOrigem === 'R'" :ctrRegPreco="contrato.ContratoRegistroPreco"/>
            <detalhes-contrato-licitacao-propria v-if="contrato.FlTipoProcedOrigem === 'P'" :ctrLicPropria="contrato.ContratoLicitacaoPropria"/>
        </card-collapse>
        <card-collapse titulo="Dados da anulação do contrato" v-if="contrato.CdSituacao === 'AN' || contrato.DtAnulacao !== null" class="w-100">
            <b-row>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Data da anulação</b></span>
                    <br />
                    <span class="pos-left">{{ contrato.DtAnulacao ? formatData(contrato.DtAnulacao) : '-' }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Motivo da anulação</b></span>
                    <br />
                    <span class="pos-left">{{ contrato.DeMotivoAnulacao }}</span>
                </b-col>
                <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                    <span><b>Baixar arquivo da anulação (PDF) *</b></span>
                    <div class="wrapper-icon">
                        <btn-download :fazerDownload="() => baixarAnexo('anulacao')" :texto="''" />
                    </div>
                </b-col>
            </b-row>
        </card-collapse>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import BtnDownload from '@/components/shared/btn-download.vue'

import contratoService from '@/services/licitacoes/contratoService'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import CardCollapse from '@/components/shared/CardCollapse.vue'
import DetalhesContratoLicitacaoOutraUg from '@/components/licitacoes/contratos/DetalhesContratoLicitacaoOutraUg.vue'
import DetalhesContratoCentralizado from '@/components/licitacoes/contratos/DetalhesContratoCentralizado.vue'
import DetalhesContratoRegistroPreco from '@/components/licitacoes/contratos/DetalhesContratoRegistroPreco.vue'
import DetalhesContratoLicitacaoPropria from '@/components/licitacoes/contratos/DetalhesContratoLicitacaoPropria.vue'


const CompProps = Vue.extend({
    name: 'DetalhesDadosGeraisContratoOF',
    components: { BtnDownload, DetalhesContratoLicitacaoOutraUg, DetalhesContratoCentralizado, DetalhesContratoRegistroPreco, DetalhesContratoLicitacaoPropria, CardCollapse },
    props: {
        contrato: {
            type: Contrato,
            required: true
        }
    }
})

@Component
export default class DetalhesDadosGeraisContratoOF extends mixins(UtilsTS, CompProps) {

    procedimentosOrigemDispensa: string[] = ["B", "D", "F"];

    async baixarAnexo(tipo: string) {
        //console.log(`baixar ${tipo} contrato`)
        const arquivo = tipo === 'edital' ? this.contrato.ArquivoTextoContrato : this.contrato.ArquivoAnulacao 
        const response = await contratoService.baixarAnexo(arquivo?.IdArquivo)
        this.download(`${tipo}-${this.contrato.NumeroAnoContrato}.pdf`, response.data)
    }
}
</script>

<style></style>